import { openBlock as r, createElementBlock as t, createElementVNode as e } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, i = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function l(c, o) {
  return r(), t("svg", i, o[0] || (o[0] = [
    e("path", {
      d: "M20.7976 17.699C22.9224 19.1183 21.5904 21.9107 19.0343 21.9107H4.96422C2.41122 21.9107 1.07764 19.1183 3.20249 17.699C5.80603 15.9587 8.86836 15.0319 12 15.0366C15.2539 15.0366 18.2795 16.0166 20.7976 17.699Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    e("path", {
      d: "M12 12C15.1715 12 16.9554 10.2161 16.9554 7.04463C16.9554 3.8732 15.1715 2.08928 12 2.08928C8.82861 2.08928 7.04468 3.8732 7.04468 7.04463C7.04468 10.2161 8.82861 12 12 12Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const p = /* @__PURE__ */ n(s, [["render", l]]);
export {
  p as U
};
